<template>
    <facet-template title="Distance" v-bind="$attrs" :collapsed="false">
        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center pb-md-2">
                <span class="d-inline-flex font-italic pr-3"> within </span>
                <distance-selector
                    :distance="distance"
                    :distance-options="distanceOptions"
                />
            </div>
            <div class="d-flex align-items-center pr-2">
                <span class="d-inline-flex font-italic px-3 of"> of </span>
                <zip-code-selector
                    :selected-zip-code="selectedZipCode"
                    :location-server-errors="locationServerErrors"
                    @zip-code-is-valid="handleZipCode"
                />
            </div>
        </div>
        <b-form-invalid-feedback class="text-center" :state="zipCodeIsValid">
            {{ validationMessage }}
        </b-form-invalid-feedback>
        <div v-if="hasServerErrors" class="server-error text-center">
            {{ locationServerErrors }}
        </div>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";
import DistanceSelector from "./DistanceSelector";
import ZipCodeSelector from "./ZipCodeSelector";
import _ from "lodash";

export default {
    name: "DistanceAndZipSelector",

    components: { FacetTemplate, DistanceSelector, ZipCodeSelector },

    props: {
        distance: {
            type: Number,
            required: true,
            default: null,
        },
        distanceOptions: {
            type: Array,
            required: true,
            default: () => [],
        },
        selectedZipCode: {
            type: String,
            required: true,
            default: "",
        },
        locationServerErrors: {
            type: [String, Array],
            required: false,
            default: null,
        },
    },

    data() {
        return {
            zipCodeIsValid: true,
            validationMessage:
                "Zip Code is required and must be exactly 5 digits.",
        };
    },

    methods: {
        handleZipCode(val) {
            this.zipCodeIsValid = val;
        },
        hasServerErrors() {
            return !_.isEmpty(this.locationServerErrors);
        },
    },
};
</script>

<style lang="scss" scoped>
.of {
    @media (min-width: 576px) {
        margin-right: 10px;
    }
}
</style>
